import { differenceInHours } from 'date-fns';
import { GenericObject } from '../types';

export const cacheResponse = async (cache: Cache, path: string, response: GenericObject) => {
  if (response.ok) {
    const resp = response.clone();
    const headers = new Headers(resp.headers);
    headers.append('cached_time', String(Date.now()));
    const data = new Response(resp.body, {
      status: resp.status,
      statusText: resp.statusText,
      headers,
    });
    await cache.put(path, data);
  }
};

export const cleanCache = async (cacheName: string, expiresAfter: number) => {
  const cache = await caches.open(cacheName);
  const keys = await cache.keys();
  keys.forEach(async key => {
    const resp = await cache.match(key.url);
    if (resp) {
      const cachedTime = resp.headers.get('cached_time');
      const hoursBeenInCache = differenceInHours(Date.now(), Number(cachedTime));
      if (hoursBeenInCache > expiresAfter) {
        await cache.delete(key.url);
      }
    }
  });
};

export const deleteCache = async (cacheName: string) => {
  const success = await caches.delete(cacheName);
  return success;
};
